import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { consumeNaverState } from "config/naver";

/**
 * ★ 2026-10-31 네이버 로그인 콜백 (/naverAuth) — KakaoCallback 과 같은 구조.
 *  - authorize 후 ?code=&state= 로 돌아옴. state 가 우리가 보낸 값이 아니면 거절(CSRF).
 *  - 사용자가 동의 취소 시 ?error=access_denied 로 돌아옴 → 로그인 화면으로.
 */
const NaverCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { naverLogin } = useAuth();
  const [msg, setMsg] = useState("네이버 로그인 처리 중…");
  const once = useRef(false); // StrictMode 이중 실행 방지(code 1회용)

  useEffect(() => {
    if (once.current) return;
    once.current = true;

    const code = params.get("code");
    const error = params.get("error");
    const state = params.get("state");
    const redirect = consumeNaverState(state);

    if (error || !code) {
      setMsg("네이버 로그인이 취소됐어요.");
      setTimeout(() => navigate("/login", { replace: true }), 1200);
      return;
    }
    if (!redirect) {
      setMsg("로그인 요청이 만료됐어요. 다시 시도해 주세요.");
      setTimeout(() => navigate("/login", { replace: true }), 1500);
      return;
    }

    (async () => {
      try {
        const result = await naverLogin(code, state);
        if (result?.isNew) {
          navigate(`/social-signup?redirect=${encodeURIComponent(redirect)}`, { replace: true });
        } else {
          navigate(redirect, { replace: true });
        }
      } catch (err) {
        setMsg(err?.response?.data?.message || "네이버 로그인에 실패했어요.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container">
      <div
        className="page"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh" }}
      >
        <p className="t-16-single">{msg}</p>
      </div>
    </div>
  );
};

export default NaverCallback;
